import { PaymentService } from '../services/PaymentService';
import { usePaymentStore } from '../state/usePaymentStore';

/**
 * Instance unique du PaymentService, liée à la config du store (lecture
 * paresseuse : toute modification admin est prise en compte immédiatement).
 */
export const paymentService = new PaymentService(
  () => usePaymentStore.getState().config,
);

export function usePaymentService(): PaymentService {
  return paymentService;
}
